import { useQuery } from '@tanstack/react-query';
import { SettingsService } from '@/api';

/**
 * Custom hook to fetch and manage site configuration settings globally
 * This hook can be used across multiple pages to access settings data
 * 
 * @returns {Object} Settings data, loading state, and refetch function
 */
export const useGlobalSettings = () => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['globalSettings'],
    queryFn: () => SettingsService.getConfiguration(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    retry: 2,
  });

  return {
    settings: data?.data || {},
    isLoading,
    error,
    refetch,
  };
};
